/** Chip: compressed label + close icon + horizontal padding. */
export const GUARDIANS_FILTER_CHIP_MIN_WIDTH_PX = 52;

/** Slot / filters button: leading icon + compressed label + horizontal padding. */
export const GUARDIANS_TOOLBAR_ACTION_MIN_WIDTH_PX = 64;

/** @deprecated Use {@link GUARDIANS_TOOLBAR_ACTION_MIN_WIDTH_PX}. */
export const GUARDIANS_TOOLBAR_SLOT_MIN_WIDTH_PX = GUARDIANS_TOOLBAR_ACTION_MIN_WIDTH_PX;
